module.exports = __webpack_public_path__ + "static/media/P11.6466f6e5.png";